import React from 'react';
import type { CameraStatus } from '@/data/dotsData';
import { CameraIcon } from '@heroicons/react/24/outline';

interface CameraBadgeProps {
  cameras: CameraStatus;
  size?: 'sm' | 'md';
}

export default function CameraBadge({ cameras, size = 'md' }: CameraBadgeProps) {
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';
  const padding  = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1';
  const iconCls  = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

  if (cameras === 'none') {
    return (
      <span className={`inline-flex items-center gap-1 rounded-md bg-muted text-muted-foreground font-medium ${textSize} ${padding}`}>
        <CameraIcon className={iconCls} />
        Sin cámara
      </span>
    );
  }
  if (cameras === 'both') {
    return (
      <span className={`inline-flex items-center gap-1 rounded-md bg-primary/10 text-primary font-medium ${textSize} ${padding}`}>
        <CameraIcon className={iconCls} />
        Cámara A + B
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-md bg-secondary text-foreground font-medium ${textSize} ${padding}`}>
      <CameraIcon className={iconCls} />
      Cámara {cameras}
    </span>
  );
}